import { render, staticRenderFns } from "./employe-create.vue?vue&type=template&id=0ae5e5ec&scoped=true"
import script from "./employe-create.vue?vue&type=script&lang=js"
export * from "./employe-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae5e5ec",
  null
  
)

export default component.exports